module.exports = __webpack_public_path__ + "static/img/3c.c727112.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/psLock/3c/3c.jpg
// module id = olAo
// module chunks = 0